import {takeEvery} from 'redux-saga/effects'
import {
  CREATE_SMS_INTEGRATION_CONNECTION,
  DELETE_SMS_INTEGRATION_CONNECTION,
  DISCONNECT_KENZER,
  GENERATE_KENZER_KEY,
  GET_KENZER_INTEGRATION,
  GET_SMS_INTEGRATIONS,
  GET_SMS_INTEGRATION_ACTIVITY,
  LAUNCH_KENZER_SSO,
  SAVE_KENZER_CONFIG,
  SET_SMS_INTEGRATION_BRANCHES,
  TEST_SMS_INTEGRATION_CONNECTION,
  UPDATE_SMS_INTEGRATION_CONNECTION,
} from 'setup/redux/Actions/SchoolIntegration/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_KENZER_INTEGRATION, fetchData)
  yield takeEvery(GENERATE_KENZER_KEY, fetchData)
  yield takeEvery(SAVE_KENZER_CONFIG, fetchData)
  yield takeEvery(DISCONNECT_KENZER, fetchData)
  yield takeEvery(LAUNCH_KENZER_SSO, fetchData)
  yield takeEvery(GET_SMS_INTEGRATIONS, fetchData)
  yield takeEvery(CREATE_SMS_INTEGRATION_CONNECTION, fetchData)
  yield takeEvery(UPDATE_SMS_INTEGRATION_CONNECTION, fetchData)
  yield takeEvery(DELETE_SMS_INTEGRATION_CONNECTION, fetchData)
  yield takeEvery(SET_SMS_INTEGRATION_BRANCHES, fetchData)
  yield takeEvery(TEST_SMS_INTEGRATION_CONNECTION, fetchData)
  yield takeEvery(GET_SMS_INTEGRATION_ACTIVITY, fetchData)
}

export default dataSaga
